module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTMuNSIgc3Ryb2tlPSJ3aGl0ZSIvPgo8bGluZSB4MT0iMjEuMjkzNCIgeTE9IjcuMjA5NTkiIHgyPSI3LjIwOTU5IiB5Mj0iMjEuMjkzNCIgc3Ryb2tlPSJ3aGl0ZSIvPgo8bGluZSB4MT0iNy4yMDk1NyIgeTE9IjYuNzA2NiIgeDI9IjIxLjI5MzQiIHkyPSIyMC43OTA0IiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/cancel_black.svg
// module id = uzDf
// module chunks = 1